<template>
  <div
    class="banner-card"
    :class="[dataClass]">
      <!--  <div class="slide-step-index" v-if="activeIndex > 0">
          {{activeIndex}}
      </div> -->
      <div class="carousel carousel-slider" ref="carousel">
        <div class="background-image" :style="itemStyles"></div>
        <transition-group>
            <div class="carousel-item grey-text" v-for="(x, i) in dataSlides" :data-target="i" :key="x.id" :class="[x.type === 'video' ? 'has-video' : '']">
              <div class="carousel-content" :class="`current-${i}`" v-if="dataSlides">
                <div class="right-content"
                  :style="x.right_content.styles"
                  v-if="x.right_content"
                  v-html="x.right_content.content">
                </div>
                <div class="inner" v-if="x.type !== 'video'">
                  <div class="slide-logo" v-if="x.logo"><img :src="x.logo" width="130px" alt=""></div>
                  <div class="area-title" :style="[{color:x.styles.textColor}]">{{x.title}}</div>
                  <div class="area-message" :style="[{color:x.styles.textColor}]" >{{x.message}}</div>
                  <button 
                    :class="x.action_classes"
                    class="btn btn-rounded waves-effect slide-action" v-if="x.hasAction"
                    @click="x.action()">
                   {{x.button.text}}
                  </button>
                </div>
                <video :ref="`video${i}`" v-if="x.type === 'video' && activeIndex === i" class="wp-video-shortcode" preload="metadata" controls="controls"><source type="video/mp4" :src="x.video">
                   <a :href="x.video">video</a>
                </video>
              </div>
            </div>
        </transition-group>
      </div>
      <div class="slide-navigation">
          <button @click="$_sliderNav('prev')"
            class="btn-prev btn-floating btn-small z-depth-2 waves-effect white">
          <i class="indigo-text text-darken-2 material-icons-outlined">arrow_back</i>
        </button>
        <button @click="$_sliderNav('next')"
          class="btn-next btn-floating btn-small z-depth-2 waves-effect white">
          <i class="indigo-text text-darken-2 material-icons-outlined">arrow_forward</i>
        </button>
      </div>
      <div class="button-area hide">
          <button class="btn white btn-rounded indigo-text text-accent-2 waves-effect" v-if="dataSlides[activeIndex].hasAction"
          @click="$_openGuide('open')">
          VIEW GUIDE
        </button>
      </div>
  </div>
</template>

<script>

import appLogo from "@/assets/act_to_adapt@2x.png";
import slideOne from '@/assets/sl_one.svg'
import clouds from '@/assets/webDots.png'
import homeSliderGraphic from '@/assets/homeSliderGraphic@2x.png'
import M from 'materialize-css'
export default {
  name: 'BannerCard',
  props: {
    dataImage: {
      type: String,
      required: false,
    },
    dataStyle: {
      type: Object,
      default: () => ({}),
    },
    dataClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      itemStyles: {
          backgroundImage: `url(${clouds})`,
          backgroundColor: 'rgb(255, 255, 255)',
          backgroundPosition: '20px 0px',
          backgroundRepeat: 'no-repeat'
        },
      homeSliderGraphic,
      dataSlides:[
       {
          id: -1,
          type:'image',
          styles:{
            backgroundSize:'cover !important',
            backgroundColor: 'rgb(255, 255, 255)',
            textColor:'rgba(0,0,0,0.9)'
          },
          logo: appLogo,
          image: slideOne,
          right_content:{
            content: `
            <div style="
              background-image:url(${homeSliderGraphic});
              background-size: auto 100%;
              position: absolute;
              left: 0;
              top: 2%;
              right: 4%;
              bottom: 0;
              background-repeat: no-repeat;
              height: 96%;
              background-position: right;
            ">
            </div>
            `,
            styles: `
            position: absolute;
            right: 0;
            top: -40px;
            bottom: -40px;
            width: 50%;
           `
          },
          title: 'Welcome to the SLDB Act to Adapt App!',
          message: '',
          button:{
            text:`View Guided Tutorial`,
          },
          action_classes:"indigo accent-2 white-text",
          hasAction: true,
          action: /* this.$_openGuide//() => {}, // */this.$_startHomeTour,
        }, 
        {
          id: 0,
          type:'image',
          styles:{
            backgroundSize:'cover !important',
            backgroundColor: 'rgb(83, 109, 254)',
            textColor:'rgba(255, 255, 255, 1)'
          },
          image: slideOne,
          right_content:{
            content: `<i style="font-size: 74px;" class="material-icons-outlined white-text text-darken-2">live_help</i>`,
            styles: `
            position: absolute;
            right: 85px;
            font-size: 24px;
            top: 50%;
            transform: translateY(-50%);`
          },
          title: 'Climate Change Home Risk Assessment Guide',
          message: 'Assess the risk of a Category 5 hurricane to your home in 3 easy, guided steps.',
          button:{
            text:`View Guide`,
          },
          hasAction: true,
          action_classes:"white indigo-text text-accent-2",
          action: this.$_openGuide
        },
      /*  {
          id: 1,
          type:'video',
          styles:{
            backgroundSize:'cover !important',
            backgroundColor: 'rgb(0, 0, 0)'
          },
          video: 'https://api.sldb.lc/wp-content/uploads/2021/04/ACT-TO-ADAPT-TVC_ver061.mp4',
          title: 'Climate Change Home Risk Assessment Guide',
          message: 'Assess the risk of a Category 5 hurricane to your home in 3 easy, guided steps.'
          
        }
         {
          id: 1,
          styles:{
            backgroundSize:'cover !important',
            backgroundColor: '#f44336'
          },
          title: 'About Your Home ',
          message: 'Get started by entering basic information about your home and its location. Upload  photos to support your selections'
        },
        {
          id: 2,
          styles:{
            backgroundColor: 'rgb(133, 178, 10)'
          },
          title: 'Complete the guided ',
          message: 'Complete the guided assessments to predict the level of impact to your home from the winds, flooding and water shortage under a Category 5 hurricane scenario. Calculate your home energy use to understand your carbon footprint. You can complete these assessments in any order you like.'
        },
        {
          id: 3,
          title: 'Assessment Summary ',
          styles:{
            backgroundColor: '#ffab00'
          },
          message: 'Put all your assessment results together in the assessment summary to identify the hazards that pose the greatest risk, the key weak points of your home and the priority home improvements you can make to reduce vulnerabilities and expected impacts.'
        }, */
      ],
      slider_options: {
      fullWidth: true,
      indicators: false,
      onCycleTo: (e) => {
        let indexVal = parseInt(e.attributes['data-target'].value)
        this.$emit('currentIndex', e.attributes['data-target'].value)
        //  this.activeIndex = -1
        setTimeout(() => {
          this.activeIndex = indexVal
          this.itemStyles.backgroundColor =  this.dataSlides[indexVal].styles.backgroundColor 
         // if(this.dataSlides[this.activeIndex].type === 'video') console.log( this.$refs[`video${indexVal}`][0].pause())
        }, 300);
        }
    },
      activeIndex:0,
      sliderInstance: null
    }
  },
  mounted() {
    this.$_initSlider()
  },
  methods: {
    $_openGuide(m = 'open') {
      this.$emit('event', m)
    },
    $_startHomeTour() {
      this.$emit('video-guides','open')
   /*    this.$store.commit('START_VIEW_GUIDE', {
        name:"overView",
        status: true
      }) */
    },
    $_sliderNav (e) {
      e === 'next'
      ? this.sliderInstance.next()
      : this.sliderInstance.prev()
    },
    $_customTruncate () {
      
    },
    $_initSlider () {
      this.sliderInstance = M.Carousel.init(
        this.$refs.carousel,
        this.slider_options
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-card {
  cursor: pointer;
  position: relative;
  border-radius: 10px;
  width: 97%; 
  margin: 12px 1.5% 24px;
  height: 270px;
  overflow: hidden;
  @media screen and (min-width: 768px) {
    height: 330px;
  }
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  .carousel-slider {
    height: 100% !important;
    min-height: 100% !important;
    .carousel-item  {
      height: 100% !important;
      min-height: 100% !important;
    }
  }
  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: .5s linear all;
  }
  .has-video {
      .carousel-content {
        padding: 0px;
      }
      video {
        width: 100%;
      }
  }
  .carousel-content  {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    padding: 0 54px 4px;
    transform: translateY(-50%);
    @media screen and (min-width: 768px) {
       padding: 0 64px 4px;
    }
}
  .area-title {
    font-size: 24px;
    line-height: 1.2;
    color: white;
    margin-bottom: 22px;
 
    font-family: "Libre Franklin", sans-serif;
    @media screen and (min-width: 768px) {
      font-size: 28px;
      color: white;
      width: 70%;
    }
  }
  .area-message {
    color: white;
    margin-bottom: 16px;
    position: relative;
    font-size: 15.5px;
    @media screen and (min-width: 768px) {
      font-size: 18px;
      width: 60%;
    }
  }
  .active {
    .slide-image, .right-content  {
      opacity: 1;
      transition: .5s linear all;
      transform: translate(0px, 0px);
    }
  }
  .right-content {
    opacity: 0;
  }
  .slide-image {
    position: absolute;
    right: 18px;
    opacity: 0;
    transition: .5s linear all;
    transform: translate(0px, 120px);
    bottom: -7px;
  }
  .slide-step-index {
    font-size: 18px;
    position: absolute;
    right: 16px;
    top: 16px;
    border-radius: 50%;
    border: 2px solid #536dfe;
    z-index: 9;
    width: 42px;
    color: #536dfe;
    height: 42px;
    text-align: center;
    line-height: 38px;
  }
  .button-area {
    position: absolute;
    bottom: 24px;
    left: 48px;
    width: calc(100% - 96px);
    button {
      width: 100%
    }
  }
  .slide-navigation {
    .btn-next {
      position: absolute;
      z-index: 9;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    }
    .btn-prev {
      position: absolute;
      z-index: 9;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }
  }
  .slide-action {
    min-width: 33%;
  }
  .inner {
    z-index: 3;
    position: relative;
  }
}
</style>
<style lang="scss">
.carousel-content {
  .right-content {
   @media screen and (max-width: 680px) {
      right: 0px;
      top: -16px !important;
      bottom: -16px !important;
      width: 50%;
   }
  }
}

</style>